import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import Cookies from 'universal-cookie';
var cookies = new Cookies();
export var getCookie = function getCookie(cookieName) {
  return cookies.get(cookieName);
};
export var setCookie = function setCookie(cookieName, data, options) {
  return cookies.set(cookieName, data, _objectSpread({
    path: '/'
  }, options));
};
export var removeCookie = function removeCookie(cookieName, options) {
  return cookies.remove(cookieName, _objectSpread({
    path: '/'
  }, options));
};
export var obscureText = function obscureText(text) {
  return typeof window === 'undefined' ? '' : btoa(decodeURIComponent(encodeURIComponent(text)));
};
export var unobscureText = function unobscureText(text) {
  return typeof window === 'undefined' ? '' : atob(decodeURIComponent(text));
};
export var obscuredStringToObject = function obscuredStringToObject(data) {
  return JSON.parse(unobscureText(data));
};
export var objectToObscuredString = function objectToObscuredString(data) {
  return obscureText(JSON.stringify(data));
};